import { GetColumnsType } from '../../../../../ui/components/TableContainer/types/propsTypes';
import { Tag, TagStyle, Theme } from '../../../../../ui/components';
import { dateTimeToCustomFormat } from '../../../../../ui/utils';
import { DynamicObjectInterface } from '../../../../../sdk/type';

// Read-only check-in submissions table for the admin participant-details page.
// Attachment file names are clickable to trigger a download (cb.onDownload),
// mirroring the participant My Progress page behaviour.
const getCheckInColumns: GetColumnsType = (styles: Object, translation: Function, cb: DynamicObjectInterface) => [
  {
    key: 'day',
    text: translation('admin.participant.checkInDay') || 'Check-In Day',
    sortable: false,
    width: 6,
    render: (row: DynamicObjectInterface) => (
      <span>{`${translation('admin.participant.checkInDay') || 'Check-In Day'} ${row.day}`}</span>
    ),
  },
  {
    key: 'attachment',
    text: translation('admin.participant.checkInAttachment') || 'Attachment',
    sortable: false,
    width: 14,
    render: (row: DynamicObjectInterface) => {
      const files = (row.files ?? []) as { photoId: number; fileName: string }[];
      if (!files.length) {
        return <span>{translation('admin.participant.checkInNoAttachment') || 'No attachment'}</span>;
      }
      return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
          {files.map((f, idx) => (
            <span
              key={`${row.key}-${f.photoId}-${idx}`}
              role="button"
              tabIndex={0}
              style={{ color: '#38539a', textDecoration: 'underline', cursor: 'pointer', wordBreak: 'break-all' }}
              onClick={() => cb?.onDownload?.(f.photoId, f.fileName)}
              onKeyDown={(e: React.KeyboardEvent) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  cb?.onDownload?.(f.photoId, f.fileName);
                }
              }}
            >
              {f.fileName}
            </span>
          ))}
        </div>
      );
    },
  },
  {
    key: 'checkInDate',
    text: translation('admin.participant.checkInDate') || 'Date',
    sortable: false,
    width: 6,
    render: (row: DynamicObjectInterface) => (
      <span>{row.checkInDate ? dateTimeToCustomFormat(row.checkInDate, 'DD/MM/yyyy') : '-'}</span>
    ),
  },
  {
    key: 'status',
    text: translation('admin.participant.checkInStatus') || 'Status',
    sortable: false,
    width: 6,
    render: (row: DynamicObjectInterface) =>
      row.submitted ? (
        <Tag text={translation('admin.participant.checkInSubmitted') || 'SUBMITTED'} theme={Theme.SUCCESS} style={TagStyle.SOLID} />
      ) : (
        <Tag text={translation('admin.participant.checkInPending') || 'PENDING'} theme={Theme.GRAY} style={TagStyle.SOLID} />
      ),
  },
];

export default getCheckInColumns;
